export const WhatsAppIcon = ({ className = "h-5 w-5" }) => (
  <svg viewBox="0 0 24 24" className={className} fill="currentColor" aria-hidden="true">
    <path d="M17.5 14.4c-.3-.15-1.75-.86-2.02-.96-.27-.1-.47-.15-.67.15-.2.3-.77.96-.94 1.16-.17.2-.35.22-.64.07-.3-.15-1.25-.46-2.38-1.47-.88-.78-1.47-1.75-1.64-2.05-.17-.3-.02-.46.13-.6.13-.14.3-.35.44-.52.15-.17.2-.3.3-.5.1-.2.05-.37-.03-.52-.07-.15-.67-1.6-.91-2.2-.24-.58-.49-.5-.67-.5h-.57c-.2 0-.52.07-.8.37-.27.3-1.04 1.02-1.04 2.48s1.07 2.88 1.22 3.08c.15.2 2.1 3.2 5.08 4.49.71.3 1.26.49 1.69.63.71.22 1.36.19 1.87.12.57-.09 1.75-.72 2-1.41.25-.69.25-1.28.17-1.41-.07-.12-.27-.2-.57-.35M12.05 21.8h-.01a9.87 9.87 0 0 1-5.03-1.38l-.36-.21-3.74.98 1-3.65-.24-.37a9.86 9.86 0 0 1-1.51-5.26c0-5.45 4.44-9.88 9.9-9.88 2.64 0 5.12 1.03 6.99 2.9a9.82 9.82 0 0 1 2.89 6.99c0 5.45-4.44 9.88-9.89 9.88m8.41-18.3A11.8 11.8 0 0 0 12.05 0C5.5 0 .16 5.33.16 11.89c0 2.1.55 4.14 1.59 5.94L.06 24l6.3-1.65a11.9 11.9 0 0 0 5.68 1.45h.01c6.55 0 11.89-5.33 11.89-11.89 0-3.18-1.24-6.16-3.48-8.41" />
  </svg>
);

export const Flag = ({ code, className = "h-5 w-5" }) => (
  <img
    src={`https://flagcdn.com/w40/${code}.png`}
    srcSet={`https://flagcdn.com/w80/${code}.png 2x`}
    alt=""
    className={`${className} rounded-full object-cover ring-1 ring-black/10`}
    loading="lazy"
  />
);

export const Stars = ({ n = 5 }) => (
  <div className="flex gap-0.5" aria-label={`${n} stars`}>
    {Array.from({ length: n }).map((_, i) => (
      <svg key={i} viewBox="0 0 20 20" className="h-4 w-4 fill-[#F59E0B]" aria-hidden="true">
        <path d="M10 1.5l2.6 5.4 5.9.8-4.3 4.1 1.1 5.8L10 14.8l-5.3 2.8 1.1-5.8L1.5 7.7l5.9-.8z" />
      </svg>
    ))}
  </div>
);

const Badge = ({ children, className = "" }) => (
  <span className={`inline-flex h-8 items-center rounded-md border border-slate-200 bg-white px-2.5 ${className}`}>{children}</span>
);

export const PaymentBadges = ({ dark = false }) => (
  <div className="flex flex-wrap items-center gap-2" data-testid="payment-badges">
    <Badge><span className="font-display text-[13px] font-extrabold italic tracking-tight text-[#1A1F71]">VISA</span></Badge>
    <Badge>
      <span className="relative flex h-4 w-7"><span className="absolute left-0 h-4 w-4 rounded-full bg-[#EB001B]" /><span className="absolute right-0 h-4 w-4 rounded-full bg-[#F79E1B] mix-blend-multiply" /></span>
    </Badge>
    <Badge><span className="font-display text-[12px] font-bold text-slate-900"> Pay</span></Badge>
    <Badge><span className="font-display text-[12px] font-bold text-slate-900"><span className="text-[#4285F4]">G</span> Pay</span></Badge>
    <Badge><span className="text-[11px] font-bold tracking-wide text-slate-700">AMEX</span></Badge>
  </div>
);
